import {
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import CardContentModal from "../../../components/modal/CardContentModal";
import CouponListModal from "../../../components/modal/CouponListModal";
import LanguageModal from "../../../components/modal/LanguageModal";
import SnowBackground from "../../../components/SnowBackground";
import ApiController from "../../../controller/ApiController";
import {
  AdvertisementType,
  CONTENT_SECTOR_TYPE,
  CONTENT_STORE_TYPE,
  ContentCardDataType,
  ContentCardDetailType,
  ContentCardType,
  ContentCategoryDataType,
  ContentSectorDataType,
  ContentStoreDataType,
  ContentType,
  EventType,
  MainSectionType,
  OwnerSectionType,
  WebStoreSelectorType,
} from "../../../controller/MasterController";
import { adverState } from "../../../recoil/adver";
import {
  authStoreType,
  masterStoreState,
  qrAuthState,
} from "../../../recoil/auth";
import { cartProductQuantityState, cartState } from "../../../recoil/cart";

import InitialGuideModal from "../../../components/modal/InitialGuideModal";
import PetalBackground from "../../../components/PetalBackground";
import LogController from "../../../controller/LogController";
import { requestNotificationPermission } from "../../../firebase";
import { adultState } from "../../../recoil/adult";
import { countState } from "../../../recoil/count";
import { langState } from "../../../recoil/lang";
import { LoadingState } from "../../../recoil/loading";
import { getDateTheme, ThemeState, ThemeType } from "../../../recoil/theme";
import { orderDetailRealmType } from "../../../recoil/type";
import AsyncLocalStorage from "../../../utils/AsyncLocalStorage";
import AdverEventContent from "../content/eventContent";
import StoreCouponDetailContent from "../content/storeCouponDetailContent";
import AroundStore from "./AroundStore";
import EventSlider from "./EventSlider";
import Header from "./Header";
import MasterStore from "./MasterStore";
import SectorCategory from "./SectorCategory";
import StoreContents from "./StoreContents";

let inactiveTimer: any;
let updateInterval: any;
let countInterval: any;

const MainPage = () => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const auth = useRecoilValue(qrAuthState);
  const currentDate = new Date();

  const [loading, setLoading] = useRecoilState<boolean>(LoadingState);
  const [isCheckAdult, setIsCheckAdult] = useRecoilState<boolean>(adultState);

  const [reset, setReset] = useState<boolean>(false);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [master, setMaster] = useRecoilState<authStoreType>(masterStoreState);
  // const [storeList, setStoreList] = useState<WebStoreSelectorType>();
  const [selectedCategory, setSelectedCategory] =
    useState<ContentSectorDataType>();
  const [inactiveTime, setInactiveTime] = useState(0);
  const [masterStoreIndex, setMasterStoreIndex] = useState<number>(0);

  const [name, setName] = useState<string>("");

  const [selectedCard, setSelectedCard] = useState<ContentCardDataType>();
  const [aroundCardList, setAroundCardList] = useState<ContentCardType[]>();
  const [selectedCardDetail, setSelectedCardDetail] =
    useState<ContentCardDetailType>();
  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);
  // 광고,이벤트
  const restTime = 60 * 1000 * 20;
  const [adverTotalList, setAdverTotalList] = useState<
    (EventType | AdvertisementType)[]
  >([]);

  const [adverStoreList, setAdverStoreList] = useState<AdvertisementType[]>([]);
  const [adverEventList, setAdverEventList] = useState<EventType | undefined>();
  const [eventView, setEventView] = useState<boolean>(true);
  const [adverFlag, setAdverFlag] = useRecoilState<boolean>(adverState);
  const [voucherContent, setVoucherContent] = useState<boolean>(false);

  // 모달
  const [visibleLanguage, setVisibleLanguage] = useState<boolean>(false);
  const [visibleCouponListModal, setVisibleCouponListModal] =
    useState<boolean>(false);
  const [visibleCard, setVisibleCard] = useState<boolean>(false);

  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);

  const [slideCount, setSlideCount] = useRecoilState<number>(countState);

  const theme = useRecoilValue<ThemeType>(ThemeState);

  let list: WebStoreSelectorType[] = [];

  const navigateStore = (
    storeList:
      | ContentStoreDataType
      | ContentStoreDataType[]
      | ContentCategoryDataType,
    index: number
  ) => {
    console.log("navigate store", storeList, index);

    navigate(`/store`, { state: { storeList, storeIndex: index } });
  };

  const navigateSector = async (item: ContentType) => {
    await getAllStoreData(item);
    if (item.content_type === CONTENT_SECTOR_TYPE) {
      setSelectedCategory(item.data as ContentSectorDataType);
      LogController.click({
        path: "StoreSelector(MainPage)",
        params: "sector",
        params2: item.data.parent_store_sector_name,
        index: item.data.parent_store_sector_id,
      });
    } else {
      navigateStore(item.data as ContentStoreDataType, -1);
    }
  };
  // 매장이동
  const findSectorItem = (storeId: number) => {
    if (
      storeList &&
      (storeList.main_section.length > 0 || storeList.owner_section.length > 0)
    ) {
      let findStore: any = {
        store_list: undefined,
        index: -1,
      };
      storeList.owner_section.map((sector: OwnerSectionType) => {
        sector.content.map((item: ContentType, index: number) => {
          if (item.content_type === CONTENT_SECTOR_TYPE) {
            const storeIndex = item.data.store_list.findIndex(
              (data: ContentStoreDataType) => data.store_id === storeId
            );
            if (storeIndex !== -1) {
              findStore = {
                content_type: CONTENT_SECTOR_TYPE,
                data: {
                  store_list: item.data.store_list,
                  index: storeIndex,
                },
              };
            }
          } else if (item.content_type === CONTENT_STORE_TYPE) {
            if (item.data.store_id === storeId) {
              findStore = {
                content_type: CONTENT_STORE_TYPE,
                data: item.data,
              };
            }
          }
        });
      });
      storeList.main_section.map((sector: MainSectionType) => {
        sector.content.map((item: ContentType, index: number) => {
          if (item.content_type === CONTENT_SECTOR_TYPE) {
            const storeIndex = item.data.store_list.findIndex(
              (data: ContentStoreDataType) => data.store_id === storeId
            );
            if (storeIndex !== -1) {
              findStore = {
                content_type: CONTENT_SECTOR_TYPE,
                data: {
                  store_list: item.data.store_list,
                  index: storeIndex,
                },
              };
            }
          } else if (item.content_type === CONTENT_STORE_TYPE) {
            if (item.data.store_id === storeId) {
              findStore = {
                content_type: CONTENT_STORE_TYPE,
                data: item.data,
              };
            }
          }
        });
      });
      return findStore;
    }
  };

  const getAllStoreData = async (content: ContentType) => {
    if (storeList) {
      if (content.content_type === "SECTOR") {
        content.data.store_list.map((store) => {
          queryClient.prefetchQuery({
            queryKey: ["details", store.store_id],
            queryFn: async () => {
              const res = await ApiController.store.getKnockStoreData({
                store_id: store.store_id,
                parent_store_id: getRecoil(masterStoreState).store_id,
                user_token_id: auth.user_token_id,
                user_id: auth.user_id,
              });
              if (res && res.data && res.data.data) {
                return res.data.data;
              } else throw new Error("details error");
            },
          });
          console.log(
            "queryData",
            store.store_id,
            queryClient.getQueryData(["details", store.store_id]),
            queryClient.getQueryCache()
          );
        });
      } else if (content.content_type === "STORE") {
        queryClient.prefetchQuery({
          queryKey: ["details", content.data.store_id],
          queryFn: async () => {
            const res = await ApiController.store.getKnockStoreData({
              store_id: content.data.store_id,
              parent_store_id: getRecoil(masterStoreState).store_id,
              user_token_id: auth.user_token_id,
              user_id: auth.user_id,
            });
            if (res && res.data && res.data.data) {
              return res.data.data;
            } else throw new Error("details error");
          },
        });
        console.log(
          "queryData",
          queryClient.getQueryData(["details", content.data.store_id])
        );
      }
    }
  };

  const navigateAdStore = (storeId: number) => {
    const findSector = findSectorItem(storeId);
    if (findSector === undefined || findSector.index === -1) {
      return;
    }
    getAllStoreData(findSector);
    if (findSector?.content_type === CONTENT_SECTOR_TYPE) {
      navigateStore(findSector.data.store_list, findSector.data.index);
    } else {
      navigateStore(findSector.data, -1);
    }
  };
  const adverClick = (storeId: number, storeName: string) => {
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "adver",
      params2: storeName,
      store_id: storeId,
      index: storeId,
    });
  };

  const getAreaInfo = async () => {
    try {
      const response = await ApiController.store.getAreaInfo(
        auth.user_id,
        auth.area_id,
        auth.room_id
      );
      console.log("getAreaInfo", response);

      if (response && response.data) {
        const oRes = response.data;
        setName(oRes.name);
      }
    } catch (err) {
      console.log("getAreaInfo err-->", err);
    }
  };

  // API 매장 정보 불러오기
  const getKnockMain = async () => {
    console.log("getKnockMain--------------------->");

    const response = await ApiController.store.getKnockMain(
      auth.user_id,
      auth.user_token_id
    );

    if (response.ok) {
      setMaster(response.data.auth_section);
    }
    return response.data;
  };

  const getStoreStatus = async () => {
    try {
      const response = await ApiController.store.getStoreStatus(auth.user_id);

      if (response.ok === true) {
        const data: WebStoreSelectorType[] = response.data;

        if (JSON.stringify(list) === JSON.stringify(data)) {
          console.log("같음");
        } else {
          console.log("다름");
          try {
            const knockMainData = await queryClient.fetchQuery({
              queryKey: ["store-list"],
              queryFn: getKnockMain,
            });

            if (knockMainData) {
              list = data;
            }
          } catch (error) {
            console.error("getKnockMain 실행 실패", error);
          }
        }
      }
    } catch (err) {
      console.log("getStoreStatus err-->", err);
    }
  };

  const { data: storeList }: UseQueryResult<WebStoreSelectorType> = useQuery({
    queryKey: ["store-list"],
    queryFn: getKnockMain,
    staleTime: 1000 * 60,
  });

  // API 광고리스트 불러오기
  const getAdverList = async () => {
    const user_id = auth.user_id;
    const user_token_id = auth.user_token_id;

    try {
      const response = await ApiController.store.getAdverList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        setAdverTotalList(oRes);
        setAdverStoreList(
          oRes.filter((data: AdvertisementType) => data.type === "adver")
        );
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  // 이벤트 불러오기
  const getEventList = async () => {
    const user_id = getRecoil(qrAuthState).user_id;
    const user_token_id = getRecoil(qrAuthState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventItem = oRes.data.find(
          (item: EventType) => item.event_type === 1
        );
        if (eventItem) {
          setAdverEventList(eventItem);
        }
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  const getAroundCard = async () => {
    const user_id = auth.user_id;
    try {
      const response = await ApiController.store.getAroundCard(user_id);

      if (response.ok) {
        setAroundCardList(response.data);
      }
    } catch (err) {
      console.log("getAroundCard err-->", err);
    }
  };
  const getCardContent = async (cardId: number) => {
    try {
      const response = await ApiController.store.getCardContent(cardId, lang);

      if (response.ok) {
        setSelectedCardDetail(response.data);
      }
    } catch (err) {
      console.log("getCardContent err-->", err);
    }
  };

  // 모달오픈
  const openCard = (item: ContentCardType) => {
    setSelectedCard(item.data);
    setVisibleCard(true);
    getCardContent(item.data.card_id);
    setVoucherContent(false);
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "card",
      params2: `${item.data.title} 카드 오픈`,
      index: item.data.card_id,
    });
  };
  const openVoucher = (item: ContentCardType) => {
    setSelectedCard(item.data);
    getCardContent(item.data.card_id);
    setVoucherContent(true);
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "voucher",
      params2: `${item.data.title} 바우처 맛집 오픈`,
      index: item.data.card_id,
    });
  };

  // cart 이동
  const cartQuantitiy = useRecoilValue(cartProductQuantityState);

  const handleCartClick = () => {
    if (cart.length > 0) {
      navigateAdStore(cart[0].store_id);
      LogController.click({
        path: "StoreSelector(MainPage)",
        params: "click",
        params2: "장바구니 버튼 클릭",
      });
    }
  };

  useEffect(() => {
    if (adverEventList && adverEventList?.used === 0) {
      setEventView(true);
    } else {
      setEventView(false);
    }
  }, [adverEventList]);

  // 광고,이벤트 시작
  const resetPage = () => {
    setReset(false);
    clearTimeout(inactiveTimer);
    inactiveTimer = null;
    startTimer();
    setAdverFlag(false);
  };
  const startTimer = () => {
    inactiveTimer = setTimeout(() => {
      setReset(true);

      setAdverFlag(true);
      setInactiveTime((prevTime) => prevTime + restTime);
    }, restTime);
  };

  const getRequestNotification = () => {
    if (process.env.REACT_APP_ENV === "PRD") {
      requestNotificationPermission();
    }
  };

  const checkInitialGuide = () => {
    AsyncLocalStorage.removeItem("initialFlag");
    getRequestNotification();
  };

  useEffect(() => {
    getAdverList();
    getEventList();
    getAroundCard();
    setReset(true);
    startTimer();

    setVoucherContent(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    setIsCheckAdult(false);
    setReset(true);

    try {
      LogController.navigate({
        path: "StoreSelector(MainPage)",
        params: "navigate",
        params2: "메인 페이지",
      });
    } catch (err: any) {
      console.log(err);
    }

    const savedFlag = AsyncLocalStorage.getItem("initialFlag");
    console.log("savedFlag", savedFlag);
    if (savedFlag) {
      setVisibleLanguage(true);
    }

    getAreaInfo();

    updateInterval = setInterval(() => {
      getStoreStatus();
      if (!moment(currentDate, "MM-DD").isSame((new Date(), "MM-DD"))) {
        setRecoil(ThemeState, getDateTheme());
      }
    }, 1000 * 60 * 5);

    setLoading(true);
    setSlideCount(-1);

    return () => {
      clearTimeout(inactiveTimer);
      clearInterval(updateInterval);
      clearInterval(countInterval);
    };
  }, []);

  useEffect(() => {
    if (storeList) {
      setTimeout(() => {
        setLoading(false);
        setSlideCount(0);
      }, 1000);
    }
  }, [storeList]);

  useEffect(() => {
    clearInterval(countInterval);

    if (
      storeList &&
      storeList.main_section.length > 0 &&
      storeList.main_section[0].content.length > 0
    ) {
      countInterval = setInterval(
        () => {
          setSlideCount(
            (slideCount + 1) % storeList.main_section[0].content.length
          );
        },
        Math.floor(slideCount % 3) === 2 ? 1500 : 400
      );
    }
  }, [slideCount]);

  useEffect(() => {
    if (inactiveTime >= restTime && !visibleLanguage && !visibleCard) {
      setReset(true);
    } else if (visibleLanguage || visibleCard) {
      setReset(false);
    }
  }, [inactiveTime, visibleCard, visibleLanguage]);

  const getBackground = () => {
    if (theme.background === "snow") {
      return <SnowBackground />;
    } else if (theme.background === "spring") {
      return <PetalBackground />;
    } else {
      return;
    }
  };

  return (
    <>
      <Style>
        <div className="knockContainer">
          <Header
            name={name}
            navigate={navigate}
            lang={lang}
            visibleLanguage={visibleLanguage}
            setVisibleLanguage={setVisibleLanguage}
            theme={theme}
          />
          {voucherContent && selectedCardDetail ? (
            <div className="voucherContentWrap">
              <StoreCouponDetailContent
                cardData={selectedCard!}
                item={selectedCardDetail}
                lang={lang}
                getCardContent={getCardContent}
                setVoucherContent={setVoucherContent}
              />
            </div>
          ) : (
            <>
              <EventSlider
                storeList={storeList}
                lang={lang}
                setVisibleCouponListModal={setVisibleCouponListModal}
                theme={theme}
              />
              <MasterStore
                storeList={storeList}
                lang={lang}
                currentDate={currentDate}
                masterStoreIndex={masterStoreIndex}
                setMasterStoreIndex={setMasterStoreIndex}
                navigateSector={navigateSector}
                openCard={openCard}
              />
              <div className="line" />
              {storeList && storeList.main_section.length > 0 && (
                <>
                  <SectorCategory
                    storeList={storeList}
                    lang={lang}
                    currentDate={currentDate}
                    selectedCategory={selectedCategory}
                    navigateSector={navigateSector}
                    navigateStore={navigateStore}
                    theme={theme}
                  />
                  <div className="line" />
                  <StoreContents
                    storeList={storeList}
                    lang={lang}
                    currentDate={currentDate}
                    navigateSector={navigateSector}
                    theme={theme}
                  />
                </>
              )}
              <div className="line" />
              {aroundCardList && aroundCardList.length > 0 && (
                <AroundStore
                  aroundCardList={aroundCardList}
                  lang={lang}
                  openVoucher={openVoucher}
                  theme={theme}
                />
              )}
            </>
          )}
          {/* 광고,이벤트 */}
          {!loading &&
            adverFlag &&
            reset &&
            (adverStoreList.length > 0 || adverEventList) && (
              <div className="mediaWrap">
                <div
                  onClick={resetPage}
                  style={{ width: "100%", height: "100dvh" }}
                ></div>
                <AdverEventContent
                  adverEventList={adverEventList}
                  adverStoreList={adverStoreList}
                  navigateAdStore={navigateAdStore}
                  adverClick={adverClick}
                  resetPage={resetPage}
                  eventView={eventView}
                  setEventView={setEventView}
                />
              </div>
            )}
          <div className="sideButtonWrap">
            {cart.length > 0 && (
              <button className={`sideButton`} onClick={handleCartClick}>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cart.svg`}
                  alt="장바구니"
                />
                <div className="count">
                  <h3>{cartQuantitiy}</h3>
                </div>
              </button>
            )}
          </div>

          {/* {!voucherContent && isVisibleArrow && (
            <div className="bottomArrowWrap">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/gif/scroll_down.gif`}
                alt="scroll_down"
              />
            </div>
          )} */}
          {getBackground()}
        </div>
      </Style>
      <LanguageModal
        isVisible={visibleLanguage}
        setVisible={setVisibleLanguage}
        lang={lang}
        setLang={setLang}
        isInitial={AsyncLocalStorage.getItem("initialFlag")}
        setVisibleGuide={setVisibleGuide}
      />
      <CardContentModal
        isVisible={visibleCard}
        setVisible={setVisibleCard}
        cardData={selectedCard!}
        cardDetailData={selectedCardDetail!}
      />
      <CouponListModal
        isVisible={visibleCouponListModal}
        setVisible={setVisibleCouponListModal}
        coupons={storeList ? storeList.coupon_section : []}
        modalType="main"
      />
      <InitialGuideModal
        isVisible={visibleGuide}
        setVisible={setVisibleGuide}
        RequestNotification={checkInitialGuide}
      />
    </>
  );
};
export default MainPage;

const Style = styled.div`
  .knockContainer {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: visible;
    background: #000;
    padding: 14px 0;
  }

  .line {
    padding: 2px 0;
    margin: 8px 14px;
    background: #262626;
    border-radius: 50px;
  }

  .row {
    display: flex;
    align-items: center;
  }

  h3 {
    font-size: 18px;
    line-height: 22px;
    color: #ffffff;
    font-weight: 200;
    margin: 0 0;
  }

  .deliveryTitle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    h2 {
      font-size: 20px;
      line-height: 26px;
      font-weight: 600;
    }
    .row {
      gap: 4px;
    }
    img {
      max-height: 26px;
    }
    .commentBox {
      padding: 4px 8px;
      background: #ffffff80;

      img {
        width: 17px;
        margin-right: 4px;
      }
      h4 {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        white-space: nowrap;
      }
    }
  }

  .normalStoreWrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    gap: 8px;
  }

  .normalStoreWrap.sector {
    gap: 10px;
  }
  .sectorItem {
    width: calc((100% - 40px) / 5);
    min-height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    padding: 6px 0;
    gap: 4px;
    img {
      width: 10vw;
      height: 10vw;
      object-fit: contain;
    }
    h3 {
      font-size: 10px;
      line-height: 14px;
      font-weight: 400;
      white-space: normal;
      word-break: break-all;
      text-align: center;
    }
  }
  .sectorItem.active {
    background: #393939;
  }

  .storeItem {
    width: calc((100% - 20px) / 3);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    .closeItem {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .closedImg {
    width: 100%;
    height: calc(100% - 28px);
    position: absolute;
    border-radius: 5px 5px 0 0;
    background: rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
    text-align: center;

    img {
      width: 150px;
      height: 150px;
    }
  }

  .titleImg {
    width: 100%;
    aspect-ratio: 5/4;
    object-fit: cover;
    border-radius: 5px;
  }

  .itemContent {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 10px;
    background: #000;

    p {
      color: #ffffff;
      font-size: 12px;
      line-height: 20px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .centerWrap {
    width: 100%;
    padding: 0 14px;
    display: flex;
    flex-direction: column;
    .line {
      margin: 10px 0;
    }
  }

  .directlyStoreWrap {
    padding: 14px;

    .row {
      gap: 14px;
      .typeButton {
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        color: #a7a7a7;
        padding: 2px 8px;
        max-width: 50%;
        z-index: 1;
      }
      .typeButton.active {
        color: #fff;
        font-weight: 600;
      }
    }

    .scrollWrap {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      margin-right: -14px;
      padding-top: 10px;
      gap: 6px;
    }

    .storeItem {
      min-width: 20vw;
      max-width: 20vw;

      .titleImg {
        aspect-ratio: 1/1;
      }
      img {
        object-fit: cover;
        border-radius: 5px;
      }
      .closedImg {
        font-size: 20px;
        line-height: 34px;
      }
      .itemContent {
        width: 100%;
        text-align: center;
        padding: 2px 8px;
      }
    }
  }

  .mediaWrap {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100dvh;
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    z-index: 100;

    .mediaBackground {
      position: absolute;
      width: 100%;
      height: 65dvh;
      background: #00000099;
      z-index: 3;
    }

    .videoWrap {
      position: relative;
      width: 100%;
      height: 65dvh;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 4;
    }

    .renderMediaWrap {
      z-index: 999;
    }
    .leftOptionWrap {
      position: absolute;
      top: 30px;
      left: 30px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      gap: 20px;
      z-index: 5;

      .mediaTitle {
        padding: 4px 24px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 5px;
        font-size: 22px;
        line-height: 32px;
        color: #ffffff;
        font-weight: 400;
      }
      img {
        cursor: pointer;
      }
    }

    .rightOptionWrap {
      position: absolute;
      top: 30px;
      right: 30px;
      z-index: 5;
    }

    .menuButton {
      position: absolute;
      display: flex;
      align-items: center;
      gap: 8px;
      bottom: 30px;
      right: 30px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 50px;
      padding: 2px 16px 2px 22px;
      font-size: 18px;
      line-height: 30px;
      color: #262626;
      font-weight: 400;
      z-index: 5;
    }

    .slider {
      width: 100vw;
      max-height: 65dvh;
    }
  }

  .timeBadge {
    padding: 6px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    border-radius: 50px;
    white-space: nowrap;
    img {
      height: 20px;
    }
  }
  .timeBadge.night {
    background: linear-gradient(180deg, #4382cd 0%, #0c2748 100%);
  }
  .timeBadge.morning {
    background: linear-gradient(
      180deg,
      #ffe03e 0%,
      #eea113 23.96%,
      #ff5f04 87.5%
    );
  }

  .badgeWrap {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    img {
      z-index: 1;
    }
  }

  .commentBox {
    width: fit-content;
    padding: 2px 4px;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    border-radius: 0 5px 5px 0;

    h5 {
      font-weight: 600;
      font-size: 8px;
      line-height: 12px;
      color: #ffffff;
    }
    h5.time {
      white-space: nowrap;
      color: #262626;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
  .commentBox.subtitle {
    background: linear-gradient(94.78deg, #46f7c7 5.9%, #64b5da 92.49%);
  }
  .commentBox.coupon {
    background: linear-gradient(94.78deg, #ffc525 5.9%, #ff4848 92.49%);
  }
  .commentBox.free {
    background: linear-gradient(94.42deg, #d185ff 7.28%, #899cff 87.52%);
    img {
      width: 12px;
      height: 12px;
      margin: 0 0 0 2px;
      vertical-align: bottom;
    }
  }
  .commentBox:nth-child(1) {
    border-top-left-radius: 5px;
  }

  .arrivalWrap {
    position: absolute;
    bottom: 32px;
    right: 4px;
    display: flex;
    align-items: center;

    .commentBox {
      background: #ffffff50;
      max-width: fit-content;
      border-radius: 50px !important;
      h5 {
        color: #262626;
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 2px;
      }
    }
  }

  .arrivalWrap.left {
    left: 0;
    bottom: 42px;

    .commentBox {
      background: #00000050;
      max-width: fit-content;
      border-radius: 0 10px 0 10px !important;
      h5 {
        color: #fff;
      }
      img {
        width: 14px;
        height: 14px;
        margin-right: 2px;
      }
    }
  }

  .sideButtonWrap {
    display: flex;
    flex-direction: column;
    gap: 24px;
    position: fixed;
    bottom: 20px;
    right: 14px;
    z-index: 4;
  }
  .sideButton {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: linear-gradient(180deg, #48f8c9 0%, #65b6da 100%);
    border-radius: 100px;
    img {
      width: 75%;
      height: 75%;
    }
    img.siren {
      position: absolute;
      width: 14px !important;
      height: 14px !important;
      z-index: 3;
      right: 21px;
      bottom: 8px;
    }
    .count {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      position: absolute;
      top: 0;
      right: 0;
      background: #ffffff;
      border-radius: 50px;
      h3 {
        font-size: 12px;
        font-weight: 700;
        color: #4dd2ae;
      }
    }
    .request {
      position: absolute;
      bottom: -10px;
      background: #ffffff;
      border: 3px solid #65b6da;
      padding: 1px 8px;
      border-radius: 50px;
      p {
        font-size: 14px;
        line-height: 16px;
        color: #65b6da;
        font-weight: 500;
      }
    }
  }
  .sideButton.inactive {
    background: #a7a7a7;
  }

  .sideButton.contact {
    background: linear-gradient(180deg, #d186ff 0%, #8a9dff 100%);
    img {
      margin-top: -8px;
    }
    .count {
      top: 2px;
      right: 2px;
      width: 24px;
      height: 24px;
      background: #ff4a4a;
      h3 {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
      }
    }
    .request {
      border-color: #8a9dff;
      p {
        color: #8a9dff;
      }
    }
  }

  .bottomArrowWrap {
    position: fixed;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    img {
      width: 100px;
    }
  }

  /* voucherContentWrap */
  .voucherContentWrap {
    padding: 30px 27px;
  }
`;
